import React, { useEffect, useState } from 'react';
import Tab from '@material-ui/core/Tab';
import TabPanel from '@material-ui/lab/TabPanel';
import TabContext from '@material-ui/lab/TabContext';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';
import { useSelector, useDispatch } from 'react-redux';
import * as commonActions from '@common/common.action';
import * as actions from './common/store/arquivamento.action';
import Arquivamento from './tabs/Arquivamento';
import Requisicao from './tabs/Requisicao';
import Relatorios from './tabs/Relatorios';
import ArquivamentoApi from './arquivamento.api';
import { acessoPermitido } from '../../acessos.seguranca';
import * as acessos from '../../acessos.const.util';
import './arquivamento.style.css';
import IntlMessage from "../../helpers/intlMessage";
import { useIntl } from 'react-intl';

function ArquivamentoPage () {
  const intl = useIntl()
  const dispatch = useDispatch();

  const usuario = useSelector(state => state.usuario);
  const currentTab = useSelector(state => state.arquivamentoCommon.tab);

  const [tecnicos, setTecnicos] = useState([]);
  const [acessoArquivamento, setAcessoArquivamento] = useState(false);
  const [acessoRequisicao, setAcessoRequisicao] = useState(false);

  useEffect(() => {
    ArquivamentoApi.getUsuario().then(resp =>
      setTecnicos([{ label:  `${intl.formatMessage({id: 'dashboards.reports.all'})}`, value: 0 }, ...resp])
    );
  }, []);

  useEffect(() => {
    setAcessoArquivamento(
      acessoPermitido(usuario, acessos.ConsultaMovimentoArquivoBlocosELaminas)
    );
    setAcessoRequisicao(
      acessoPermitido(usuario, acessos.RequisicaoEDevolucaoBlocosELaminas)
    );
  }, [usuario]);

  useEffect(() => {
    setTimeout(() => setTab(), 200);
  }, [acessoArquivamento, acessoRequisicao]);

  const setTab = () => {
    if (acessoArquivamento) {
      dispatch(actions.atualizarTab('1'));
      return;
    }
    if (acessoRequisicao) {
      dispatch(actions.atualizarTab('2'));
      return;
    }

    dispatch(actions.atualizarTab('3'));
  };

  const mudarAba = (event, tab) => {
    dispatch(actions.atualizarTab(tab));
  };

  const showMessageByResults = results => {
    if (results > 0) {
      const mensagem = <IntlMessage id = "dashboards.general.recordsFound"/>
      dispatch(commonActions.showAlerta('sucesso', mensagem, 3000));
    } else {
      dispatch(
        commonActions.showAlerta('alerta', <IntlMessage id = "dashboards.reports.noResultsFound"/>, 3000)
      );
    }
  };

  return (
    <div className='mv-arquivamento-page'>
      <TabContext value={currentTab}>
        <AppBar position='static' color='default'>
          <Tabs
            value={currentTab}
            onChange={mudarAba}
            variant='scrollable'
            //scrollButtons='on'
            indicatorColor='primary'
            textColor='primary'
            aria-label='scrollable force tabs example'
          >
            {acessoArquivamento && (
              <Tab
                icon={<i className='tab-icons mv-basico-arquivar'></i>}
                label={`${intl.formatMessage({id: 'dashboards.reports.materialArchiving'})}`}
                value='1'
              />
            )}
            {acessoRequisicao && (
              <Tab
                icon={<i className='tab-icons mv-basico-desarquivar'></i>}
                label={<IntlMessage id = "dashboards.reports.materialRequest"/>}
                value='2'
              />
            )}

            <Tab
              icon={
                <i className='tab-icons mv-basico-documento_eletronico'></i>
              }
              label={<IntlMessage id = "dashboards.disposalMaterials.reports"/>}
              value='3'
            />

            <Tab value='0' disabled></Tab>
          </Tabs>
        </AppBar>

        <TabPanel value='0'></TabPanel>
        {acessoArquivamento && (
          <TabPanel value='1'>
            <Arquivamento
              tecnicos={tecnicos}
              showMessageByResults={showMessageByResults}
            />
          </TabPanel>
        )}
        {acessoRequisicao && (
          <TabPanel value='2'>
            <Requisicao
              tecnicos={tecnicos}
              showMessageByResults={showMessageByResults}
            />
          </TabPanel>
        )}

        <TabPanel value='3'>
          <Relatorios showMessageByResults={showMessageByResults} />
        </TabPanel>
      </TabContext>
    </div>
  );
}

export default ArquivamentoPage;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/arquivamento.page.js